"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountRestrictionsInfoBuilder = void 0;

var AccountRestrictionAddressValueBuilder_1 = require("./AccountRestrictionAddressValueBuilder");

var AccountRestrictionFlagsDto_1 = require("./AccountRestrictionFlagsDto");

var AccountRestrictionMosaicValueBuilder_1 = require("./AccountRestrictionMosaicValueBuilder");

var AccountRestrictionTransactionTypeValueBuilder_1 = require("./AccountRestrictionTransactionTypeValueBuilder");

var GeneratorUtils_1 = require("./GeneratorUtils");

var AccountRestrictionsInfoBuilder = /*#__PURE__*/function () {
  function AccountRestrictionsInfoBuilder(restrictionFlags, addressRestrictions, mosaicIdRestrictions, transactionTypeRestrictions) {
    _classCallCheck(this, AccountRestrictionsInfoBuilder);

    GeneratorUtils_1.GeneratorUtils.notNull(restrictionFlags, 'restrictionFlags is null or undefined');

    if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.ADDRESS) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(addressRestrictions, 'addressRestrictions is null or undefined');
    }

    if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.MOSAIC_ID) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(mosaicIdRestrictions, 'mosaicIdRestrictions is null or undefined');
    }

    if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.TRANSACTION_TYPE) > -1) {
      GeneratorUtils_1.GeneratorUtils.notNull(transactionTypeRestrictions, 'transactionTypeRestrictions is null or undefined');
    }

    this.restrictionFlags = restrictionFlags;
    this.addressRestrictions = addressRestrictions;
    this.mosaicIdRestrictions = mosaicIdRestrictions;
    this.transactionTypeRestrictions = transactionTypeRestrictions;
  }

  _createClass(AccountRestrictionsInfoBuilder, [{
    key: "getRestrictionFlags",
    value: function getRestrictionFlags() {
      return this.restrictionFlags;
    }
  }, {
    key: "getAddressRestrictions",
    value: function getAddressRestrictions() {
      if (!(this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.ADDRESS) > -1 && this.addressRestrictions)) {
        throw new Error('restrictionFlags is not set to ADDRESS.');
      }

      return this.addressRestrictions;
    }
  }, {
    key: "getMosaicIdRestrictions",
    value: function getMosaicIdRestrictions() {
      if (!(this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.MOSAIC_ID) > -1 && this.mosaicIdRestrictions)) {
        throw new Error('restrictionFlags is not set to MOSAIC_ID.');
      }

      return this.mosaicIdRestrictions;
    }
  }, {
    key: "getTransactionTypeRestrictions",
    value: function getTransactionTypeRestrictions() {
      if (!(this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.TRANSACTION_TYPE) > -1 && this.transactionTypeRestrictions)) {
        throw new Error('restrictionFlags is not set to TRANSACTION_TYPE.');
      }

      return this.transactionTypeRestrictions;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = 0;
      size += 2;

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.ADDRESS) > -1) {
        size += this.addressRestrictions.getSize();
      }

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.MOSAIC_ID) > -1) {
        size += this.mosaicIdRestrictions.getSize();
      }

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.TRANSACTION_TYPE) > -1) {
        size += this.transactionTypeRestrictions.getSize();
      }

      return size;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);
      var restrictionFlagsBytes = GeneratorUtils_1.GeneratorUtils.uint16ToBuffer(GeneratorUtils_1.GeneratorUtils.fromFlags(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto, this.restrictionFlags));
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, restrictionFlagsBytes);

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.ADDRESS) > -1) {
        var addressRestrictionsBytes = this.addressRestrictions.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, addressRestrictionsBytes);
      }

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.MOSAIC_ID) > -1) {
        var mosaicIdRestrictionsBytes = this.mosaicIdRestrictions.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, mosaicIdRestrictionsBytes);
      }

      if (this.restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.TRANSACTION_TYPE) > -1) {
        var transactionTypeRestrictionsBytes = this.transactionTypeRestrictions.serialize();
        newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, transactionTypeRestrictionsBytes);
      }

      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var restrictionFlags = GeneratorUtils_1.GeneratorUtils.toFlags(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto, GeneratorUtils_1.GeneratorUtils.bufferToUint16(Uint8Array.from(byteArray)));
      byteArray.splice(0, 2);
      var addressRestrictions = undefined;

      if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.ADDRESS) > -1) {
        addressRestrictions = AccountRestrictionAddressValueBuilder_1.AccountRestrictionAddressValueBuilder.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, addressRestrictions.getSize());
      }

      var mosaicIdRestrictions = undefined;

      if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.MOSAIC_ID) > -1) {
        mosaicIdRestrictions = AccountRestrictionMosaicValueBuilder_1.AccountRestrictionMosaicValueBuilder.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, mosaicIdRestrictions.getSize());
      }

      var transactionTypeRestrictions = undefined;

      if (restrictionFlags.indexOf(AccountRestrictionFlagsDto_1.AccountRestrictionFlagsDto.TRANSACTION_TYPE) > -1) {
        transactionTypeRestrictions = AccountRestrictionTransactionTypeValueBuilder_1.AccountRestrictionTransactionTypeValueBuilder.loadFromBinary(Uint8Array.from(byteArray));
        byteArray.splice(0, transactionTypeRestrictions.getSize());
      }

      return new AccountRestrictionsInfoBuilder(restrictionFlags, addressRestrictions, mosaicIdRestrictions, transactionTypeRestrictions);
    }
  }, {
    key: "createAccountRestrictionsInfoBuilder",
    value: function createAccountRestrictionsInfoBuilder(restrictionFlags, addressRestrictions, mosaicIdRestrictions, transactionTypeRestrictions) {
      return new AccountRestrictionsInfoBuilder(restrictionFlags, addressRestrictions, mosaicIdRestrictions, transactionTypeRestrictions);
    }
  }]);

  return AccountRestrictionsInfoBuilder;
}();

exports.AccountRestrictionsInfoBuilder = AccountRestrictionsInfoBuilder;